import React, { useEffect } from 'react';
import "./Home.css";
import Section1 from "./Section1";
import WaveSection from './WaveSection';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import Aboutus from './Aboutus';
import Services from './Services';
import Countingsection from './Countingsection';
import Testimonials from './Testimonials';
import FAQ from './FAQ';


import PricesSection from './PricesSection';
import Whytaxwithus from './Whytaxwithus';
import Upperbox from './Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

import Cosection from '../components/Cosections';
const Home = () => {
  useEffect(() => {
    // Scroll to the top when the page is loaded
    window.scrollTo(0, 0);
  }, []);

  
    
      return (
  <div className="home-page">
    <NavBar />
    <Section1 />
    <Countingsection />
    <Whytaxwithus />
    <Testimonials />
    <FAQ />
    <Cosection />
    
    <Whatsapp />
    <ScrollTop />
    <Footer />
  </div>
);

    
  
};

export default Home;
